import { BaseModel } from "sjs-base-model";

export default class CercaDettalgioPreventivoModel extends BaseModel {
    public readonly idEstimate: string = "";
    public readonly idEstimateRequest: string = "";
    public readonly idPractice: string = "";
    public readonly idSimulation: string = "";
    public readonly simulationName: string = "";
    public readonly idRequestType: number = 0;
    public readonly requestType: string = "";
    public readonly idChannel: number = 0;
    public readonly channel: string = "";
    public readonly sourceType: number = 0;
    public readonly sourceDetail: string = "";
    public readonly idSegment: number = 0;
    public readonly segment: string = "";
    public readonly idProduct: number = 0;
    public readonly product: string = "";
    public readonly atc: string = "";
    public readonly idAtc: number = 0;
    public readonly customerType: string = "";
    public readonly idAdministrativeCategory: number = 0;
    public readonly agent: string = "";
    public readonly idAgent: number = 0;
    public readonly installment: number = 0;
    public readonly duration: number = 0;
    public readonly futureValue: number = 0;
    public readonly commissions: number = 0;
    public readonly amount: number = 0;
    public readonly balance: number = 0;
    public readonly rc: string = "";
    public readonly rv: string = "";
    public readonly estimateDate: string = "";
    public readonly isExpired: boolean = false;
    public readonly firstName: string = "";
    public readonly lastName: string = "";
    public readonly gender: string = "";
    public readonly birthNation: string = "";
    public readonly birthPlace: string = "";
    public readonly birthPlaceCode: string = "";
    public readonly birthCounty: string = "";
    public readonly birthDate: string = "";
    public readonly fiscalCode: string = "";
    public readonly residenceNation: string = "";
    public readonly residencePlaceCode: string = "";
    public readonly residencePlace: string = "";
    public readonly residenceCounty: string = "";
    public readonly residenceAddress: string = "";
    public readonly residenceCivicNumber: string = "";
    public readonly residencePlaceAbroad: string = "";
    public readonly mobilePhone: string = "";
    public readonly mail: string = "";
    public readonly thirdPartiesYearExtinctions: boolean = false;
    public readonly existingExtinctions: number = 0;
    public readonly existingAssignment: boolean = false;
    public readonly tan: number = 0;
    public readonly teg: number = 0;
    public readonly taeg: number = 0;
    public readonly irr: number = 0;
    public readonly residenceAddressType: string = "";
    public readonly idSignProcess: string = "";
    public readonly idAnag?: number = undefined;
    public readonly typeId?: number = undefined;

    constructor(data: Partial<CercaDettalgioPreventivoModel>) {
        super();

        this.update(data);
    }
}
